import { Component, NgModule } from '@angular/core';


@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})

export class HeaderComponent {
  target: any;

  config: SwiperOptions = {
    pagination: '.swiper-pagination',
    paginationClickable: true,
    nextButton: '.swiper-button-next',
    prevButton: '.swiper-button-prev',
    spaceBetween: 30
  };
  images = [
    // 'assets/images/temp-hero-image.jpg',
    // 'assets/images/hero/2015-02-10 063.JPG',
    // 'assets/images/hero/2015-02-14 198.JPG',
    // 'assets/images/hero/2015-02-15 035.JPG',
    // 'assets/images/hero/IMG_1304 (1).jpg',
    // 'assets/images/hero/KROW0452.jpg',
    'assets/images/hero/KROW0456.jpg',
    // 'assets/images/hero/KROW0737.jpg'
  ];

  slideCount = this.images.length;

  constructor() { }

  public scrollToProducts() {
    const element = document.getElementById('products');

    element.scrollIntoView({behavior: 'smooth', block: 'start', inline: 'nearest'});
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/header/header.component.ts